import React from "react";

export default function BasicInfoIcon() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="7" y1="64" x2="20" y2="64" stroke="#0A4763" strokeWidth="4" strokeLinecap="round" />
      <line x1="6" y1="12" x2="53" y2="12" stroke="#0A4763" strokeWidth="4" strokeLinecap="round" />
      <line x1="6" y1="36" x2="31" y2="36" stroke="#0A4763" strokeWidth="4" strokeLinecap="round" />
      <path
        d="M33 63.7482V54.5601L67.5552 20.0049L76.5435 28.9932L41.7886 63.7482H33Z"
        stroke="#0A4763"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.3613 25.3984L71.7504 33.7876"
        stroke="#0A4763"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
